import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const OLGPRSApi = createApi({
  reducerPath: "OLGPRSApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["OLGPRSApi"],
  endpoints: (build) => ({
    getAllOlgprsCounts: build.mutation({
      query: ({ id }) => ({
        url: `/index.php?VALUE=count`,
        method: "POST",
        body: { id: id },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["OLGPRSApi"],
    }),

    //     getTeacherById: build.query({
    //       query: ({ id }) => ({
    //         url: `/teachers/${id}`,
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       providesTags: ["OLGPRSApi"],
    //     }),

    //     editTeacher: build.mutation({
    //       query: ({ id, data }) => ({
    //         url: `/teachers/${id}`,
    //         method: "PUT",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OLGPRSApi"],
    //     }),

    //     addTeacher: build.mutation({
    //       query: (data) => ({
    //         url: `/teachers`,
    //         method: "POST",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OLGPRSApi"],
    //     }),

    //     deleteTeacher: build.mutation({
    //       query: (id) => ({
    //         url: `/teachers/${id}`,
    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       invalidatesTags: ["OLGPRSApi"],
    //     }),
  }),
});

export const { useGetAllOlgprsCountsMutation } = OLGPRSApi;
